export const DATE_FORMAT = 'yyyyMMdd';

export const W8_EXPIRING_MAX_MONTHS = 2;

export const PRIVATE_WEALTH_ACCOUNT_TYPE = 'PWEALTH';
